module.exports = __webpack_public_path__ + "static/media/index_banner.fb0b19d9.png";